// used for various case colors e.g. bars
export const CHARTS_LIGHT_BLUE = '#83c6e0';

// used as the case average line
export const CHARTS_DARK_BLUE = '#1281aa';
